/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import MicrosoftOutlookRegular from './microsoft-outlook-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <MicrosoftOutlookRegular {...validProps} />;
}
SvgComponent.iconName = 'microsoftOutlookRegular';

export const MicrosoftOutlookRegularIcon = svgIconWrapper(SvgComponent);
